/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import Button from "@material-ui/core/Button";
import { useI18n } from "hooks/i18n/i18n";

import type { FC } from "react";

type Props = {
  pawBalance: JSX.Element;
  onClick: () => void;
};

export const AccountCurrentPaw: FC<Props> = ({ pawBalance, onClick }) => {
  const { t } = useI18n();
  const classes = styles();

  return (
    <section css={classes.root}>
      <div css={classes.layout}>
        <div>
          <h2 css={classes.heading}>{t("account.ownedPAW")}</h2>
          <div>{pawBalance}</div>
        </div>

        <Button
          css={classes.chargeButton}
          type="button"
          aria-label={t("account.topUpPAW")}
          onClick={onClick}
        >
          {t("account.topUpPAW")}
        </Button>
      </div>
    </section>
  );
};

const styles = () => ({
  root: css`
    padding: 15px 0;
    background-color: #f9f9f9;
    border-bottom: 1px solid #e6e5e6;
  `,
  layout: css`
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    align-items: center;
    gap: 24px;
    width: 90%;
    max-width: 740px;
    margin: 0 auto;
  `,
  heading: css`
    font-size: 14px;
  `,
  chargeButton: css`
    &.MuiButton-root {
      width: 100%;
      max-width: 270px;
      padding: 8px 32px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      background-color: #00c2ae;
      border-radius: 0;
      @media screen and (min-width: 768px) {
        padding: 8px 64px;
        font-size: 14px;
      }
    }
    &.MuiButton-root:hover {
      background-color: #00c2ae;
    }
  `,
});
